import { AuthEvents } from '../../config/auth-enumerations'

/** Fires `gbpe:authStateUpdated` on `window` so host apps (e.g. Skyhawk Nav) can react after auth state is set. */
export function dispatchGbpeAuthStateUpdated(): void {
	window.dispatchEvent(new CustomEvent(AuthEvents.authStateUpdated))
}
